import { isEmpty, maxBy } from 'lodash';
import { mapState } from 'vuex';
import { CONTRACTS, COLOR_MAP, PRICE_FACTORS, COLOR_INDEXES } from '@/components/pages/page-election-map-new/election-map/election-map.vue';

export default {
  data() {
    return {
      ready: false,
    };
  },
  computed: {
    ...mapState('market', ['mapStateData']),
    meStyleModifiers() {
      return this.getContractInfo('ME');
    },
    me1StyleModifiers() {
      return this.getContractInfo('ME-01');
    },
    me2StyleModifiers() {
      return this.getContractInfo('ME-02');
    },
    me3StyleModifiers() {
      return this.getContractInfo('ME-03');
    },
    neStyleModifiers() {
      return this.getContractInfo('NE');
    },
    ne1StyleModifiers() {
      return this.getContractInfo('NE-01');
    },
    ne2StyleModifiers() {
      return this.getContractInfo('NE-02');
    },
    ne3StyleModifiers() {
      return this.getContractInfo('NE-03');
    },
  },
  watch: {
    mapStateData: {
      handler: 'mapStateDataHandler',
      immediate: true,
    },
  },
  methods: {
    getContractInfo(key) {
      const data = this.mapStateData[key] || null;
      if (data === null) {
        return {
          background: COLOR_MAP.GRAY[COLOR_INDEXES.MEDIUM].color,
        };
      }
      const targetContract = maxBy(data.contracts, j => j.lastTradePrice);
      const colorMap = (targetContract.contractName === CONTRACTS.DEMOCRATIC)
        ? COLOR_MAP.BLUE
        : COLOR_MAP.RED;
      let index = null;
      if (targetContract.lastTradePrice <= PRICE_FACTORS.LOW) {
        index = COLOR_INDEXES.LOW;
      } else if (targetContract.lastTradePrice <= PRICE_FACTORS.MEDIUM) {
        index = COLOR_INDEXES.MEDIUM;
      } else if (targetContract.lastTradePrice <= PRICE_FACTORS.HIGH) {
        index = COLOR_INDEXES.HIGH;
      }
      return {
        color: '#fff',
        background: colorMap[index].color,
      };
    },
    mapStateDataHandler(value) {
      if (!isEmpty(value)) {
        this.ready = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-election-map-new/election-map-table/election-map-table.js